/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RelatoriosAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_GERAR = 'button-gerar',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_0 = 'fetch-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_RELATORIO = 'field-relatorio',
  FORM_0 = 'form-0',
  FORM_DYNAMIC = 'form-dynamic',
  LAYOUT_0 = 'layout-0',
  LAYOUT_INFO_ADICIONAL = 'layout-info-adicional',
  MAPPER_0 = 'mapper-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_DYNAMIC = 'panel-dynamic',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
}
export { RelatoriosAliases };
